module.exports = __webpack_public_path__ + "media/images/favicon-00b41bd6970002f295a9446073b7c0a6.ico";